var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "error404 error-page", staticStyle: { height: "100vh" } },
    [
      _c("div", { staticClass: "main-wrapper" }, [
        _c(
          "div",
          { staticClass: "error-box" },
          [
            _c("h1", [_vm._v("404")]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("p", [_vm._v("The page you requested was not found.")]),
            _vm._v(" "),
            _c(
              "router-link",
              { staticClass: "btn btn-custom", attrs: { to: "/index" } },
              [_vm._v("Back to Home")]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("i", { staticClass: "fa fa-warning" }),
      _vm._v(" Oops! Page not found!")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-456ae380", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-456ae380","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/error404.vue
// module id = null
// module chunks = 